import * as React from 'react';
import { observer } from 'mobx-react-lite';
import styled from '@emotion/styled';
import { mainColors } from '../../assets/colors';


export const buildBtnColor = (btnColor: string): string | undefined => {

    if (btnColor === 'confirm') {
        return `
            background-color: ${mainColors.main.secondary}};
        `;
    }

    if (btnColor === 'reject') {
        return `
            background-color: ${mainColors.status.error};
        `;
    }

    if (btnColor === 'info') {
        return `
            color: ${mainColors.main.secondary};
            background-color: ${mainColors.default.light};
            border: solid 2px ${mainColors.main.secondary};
        `;
    }
};

const ButtonWithIconWrapper = styled('button', { label: 'ButtonWithIconWrapper' }) <{ isDisabled?: boolean; isIcon: boolean; btnColor?: string }>`
    border: none;
    border-radius: 4px;
    cursor: ${({ isDisabled }): string => isDisabled === true ? 'not-allowed' : 'pointer'};
    color: ${mainColors.default.light};
    display: inline-flex;
    font-size: 14px;
    font-weight: bold;
    line-height: 1;
    max-height: 32px;
    margin-right: 4px;
    opacity: ${({ isDisabled }): number => isDisabled === true ? 0.4 : 1};
    padding: 8px;
    transition: .3s ease background-color;

    &:hover{
                opacity: ${({ isDisabled }): number | string => isDisabled === true ? 'none' : 0.8};
            };

    ${({ btnColor = 'primary' }): string | undefined => buildBtnColor(btnColor)};

`;

interface ButtonWithIconPropsType {
    onClick?: () => void,
    children: React.ReactNode,
    className?: string,
    icon?: JSX.Element,
    isDisabled?: boolean
    btnColor?: 'confirm' | 'reject' | 'info',
    dataTest?: string
}

export const ButtonWithIcon = observer(({ onClick, children, className, icon, isDisabled, btnColor, dataTest }: ButtonWithIconPropsType) => {
    return (
        <ButtonWithIconWrapper
            className={className}
            onClick={isDisabled === true ? undefined : onClick}
            isDisabled={isDisabled}
            isIcon={icon !== undefined}
            btnColor={btnColor}
            data-test={dataTest}
        >
            {icon}
            {children}
        </ButtonWithIconWrapper>
    );
});
